import { Signal } from "typed-signals";

export class BetsLadderControl {
    onTotalBetChanged = new Signal();
    onValuesChanged = new Signal();

    constructor(betsLadder) {
        this._betsLadder = betsLadder || [];
        this._betValues = [...new Set(this._betsLadder.map((e) => e.bet))].sort((a, b) => a - b);
        this._coinValues = [...new Set(this._betsLadder.map((e) => e.coinValue))].sort((a, b) => a - b);
        this._totalBets = [...new Set(this._betsLadder.map((e) => e.totalBet))].sort((a, b) => a - b);

        const first = this._betsLadder[0];
        this._bet = first?.bet ?? 0;
        this._coinValue = first?.coinValue ?? 0;
        this._totalBet = first?.totalBet ?? 0;
    }

    get bet() { return this._bet; }
    get coinValue() { return this._coinValue; }
    get totalBet() { return this._totalBet; }

    get betValues() { return this._betValues; }
    get coinValues() { return this._coinValues; }
    get totalBets() { return this._totalBets; }

    setTotalBet(value) {
        const entry = this._findClosestLadderEntry(value);
        if (!entry) return;
        this._bet = entry.bet;
        this._coinValue = entry.coinValue;
        this._totalBet = entry.totalBet;
        this.onValuesChanged.emit({ bet: this._bet, coinValue: this._coinValue, totalBet: this._totalBet });
    }

    nextTotalBet() { this._applyEntry(this._findNextTotalBet(this._totalBet, 1)); }
    previousTotalBet() { this._applyEntry(this._findNextTotalBet(this._totalBet, -1)); }

    nextBetValue() {
        const i = this._betValues.indexOf(this._bet);
        const next = Math.min(i + 1, this._betValues.length - 1);
        this._applyEntry(this._findLadderEntry(this._betValues[next], this._coinValue));
    }

    previousBetValue() {
        const i = this._betValues.indexOf(this._bet);
        const next = Math.max(i - 1, 0);
        this._applyEntry(this._findLadderEntry(this._betValues[next], this._coinValue));
    }

    nextCoinValue() {
        const i = this._coinValues.indexOf(this._coinValue);
        const next = Math.min(i + 1, this._coinValues.length - 1);
        this._applyEntry(this._findLadderEntry(this._bet, this._coinValues[next]));
    }

    previousCoinValue() {
        const i = this._coinValues.indexOf(this._coinValue);
        const next = Math.max(i - 1, 0);
        this._applyEntry(this._findLadderEntry(this._bet, this._coinValues[next]));
    }

    setBetMax() {
        this._applyEntry(this._betsLadder[this._betsLadder.length - 1]);
    }

    _findLadderEntry(bet, coinValue) {
        return this._betsLadder.find((e) => e.bet === bet && e.coinValue === coinValue);
    }

    _findClosestLadderEntry(targetTotalBet) {
        if (this._betsLadder.length === 0) return undefined;
        let closest = this._betsLadder[0];
        let minDiff = Math.abs(closest.totalBet - targetTotalBet);
        for (const entry of this._betsLadder) {
            const diff = Math.abs(entry.totalBet - targetTotalBet);
            if (diff < minDiff) {
                minDiff = diff;
                closest = entry;
            }
        }
        return closest;
    }

    _findNextTotalBet(currentTotalBet, direction) {
        const i = this._totalBets.indexOf(currentTotalBet);
        if (i === -1) return this._findClosestLadderEntry(currentTotalBet);
        const next = i + direction;
        if (next < 0) return this._findClosestLadderEntry(this._totalBets[0]);
        if (next >= this._totalBets.length) return this._findClosestLadderEntry(this._totalBets[this._totalBets.length - 1]);
        return this._findClosestLadderEntry(this._totalBets[next]);
    }

    _applyEntry(entry) {
        if (!entry) return;
        const totalBetChanged = this._totalBet !== entry.totalBet;
        this._bet = entry.bet;
        this._coinValue = entry.coinValue;
        this._totalBet = entry.totalBet;
        this.onValuesChanged.emit({ bet: this._bet, coinValue: this._coinValue, totalBet: this._totalBet });
        if (totalBetChanged) {
            this.onTotalBetChanged.emit(this._totalBet);
        }
    }
}
